import * as Models from "../Models";
import * as Common from "../Common/modules";

    export interface IInvoiceApiClient {
        previewInvoice: (invoiceNumber: string) => ng.IPromise<any>;
        getSolarInvoiceListForCustomer: (igsCustomerNumber: string) => ng.IPromise<any>;
        resendInvoice: (request: Models.Customer.ResendInvoiceRequest.ResendInvoiceRequest) => ng.IPromise<any>;
        previewPdfInvoice: (documentKey: string, download: string) => ng.IPromise<any>;
        openInvoiceTab: (documentKey: string) => ng.IPromise<any>;
    }

    export class InvoiceApiClient implements IInvoiceApiClient {
        public static $inject = ['igs.apiClientService'];

        constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        }

        public previewInvoice = (invoiceNumber: string): ng.IPromise<any> => {
            var url = `Invoice/${invoiceNumber}/HtmlView`;
            return this.igsApiClientService.get(url);
        }

        public getSolarInvoiceListForCustomer = (igsCustomerNumber: string): ng.IPromise<any> => {
            var url = `Customer/${igsCustomerNumber}/Invoices`;
            return this.igsApiClientService.get(url);
        }

        public resendInvoice = (resendInvoiceRequest: Models.Customer.ResendInvoiceRequest.ResendInvoiceRequest): ng.IPromise<any> => {
            var url = `Invoices/${resendInvoiceRequest.invoiceNumber}/Resend`;
            return this.igsApiClientService.post(url, resendInvoiceRequest);
        }

        public previewPdfInvoice = (documentKey: string, download: string): ng.IPromise<any> => {
            var url = `Invoices/${documentKey}/GetInvoicePdfData/${download}`;
            return this.igsApiClientService.get(url);
        }

        public openInvoiceTab = (documentKey: string): ng.IPromise<any> => {
            var url = `Invoices/OpenInvoiceTab/${documentKey}`;
            return this.igsApiClientService.get(url);
        }
    }
